export const ACTIVE_DRIVERS_LIST_POLLING_INTERVAL = 5000;

export const INDIVIDUAL_DRIVER_POLLING_INTERVAL = 5000;

export const MOCK_DRIVER_UPDATE_INTERVAL = 120000;
